module.exports = __webpack_public_path__ + "close-white.png?599b6df3c906befba47e7e146c2e875e";